var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-layout',{attrs:{"wrap":""}},[_c('v-container',{attrs:{"fluid":"","grid-list-md":"","pa-1":""}},[_c('v-layout',{attrs:{"row":"","align-start":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":"","lg6":"","xl6":""}},[_c('components')],1)],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }